import React, { useEffect, useState } from 'react'
import { AeronetViewProps } from '../types'
import { Route, Routes } from 'react-router-dom'
import { getOriginalUrl } from '../utils/originalUrl'
import DueDateList from './DueDateList'
import DueDateDetail from './DueDateDetail'
import { useCurrentUser } from '../hooks/useCurrentUser'
import { useConfig } from '../hooks/useConfig'

const DueDate: React.FC<React.PropsWithChildren<AeronetViewProps>> = (props)  => {
  const { originalUrl: domain, ...otherProps } = props;
  const originalUrl = getOriginalUrl(domain, "function=due_date_control");

  const currentUser = useCurrentUser();
  const whiteboardConfig = useConfig("whiteboard");
  const [hasDueDateCreatePermission, setHasDueDateCreatePermission] = useState<boolean>(false);
  const [hasDueDateEditPermission, setHasDueDateEditPermission] = useState<boolean>(false);
  const [hasDueDateDeletePermission, setHasDueDateDeletePermission] = useState<boolean>(false);
  const [hasDueDatePermission, setHasDueDatePermission] = useState<boolean>(false);

  useEffect(() => {
    if (whiteboardConfig && currentUser) {
      // Roxen gates New Record with Edit (not Create).
      if (
        whiteboardConfig.Edit &&
        currentUser.permissions?.whiteboard &&
        currentUser.permissions.whiteboard.includes(whiteboardConfig.Edit)
      ) {
        setHasDueDateCreatePermission(true);
        setHasDueDateEditPermission(true);
      } else {
        setHasDueDateCreatePermission(false);
        setHasDueDateEditPermission(false);
      }

      if (
        whiteboardConfig.Delete &&
        currentUser.permissions?.whiteboard &&
        currentUser.permissions.whiteboard.includes(whiteboardConfig.Delete)
      ) {
        setHasDueDateDeletePermission(true);
      } else {
        setHasDueDateDeletePermission(false);
      }
      if (
        whiteboardConfig.can_view_module_log &&
        currentUser.permissions?.whiteboard &&
        currentUser.permissions.whiteboard.includes(whiteboardConfig.can_view_module_log)
      ) {
        setHasDueDatePermission(true);
      } else {
        setHasDueDatePermission(false);
      }
    }
  }, [currentUser, whiteboardConfig]);

  return (
    <Routes>
      <Route
        path="create"
        element={
          <DueDateDetail
            originalUrl={originalUrl}
            canEdit={hasDueDateEditPermission}
          />
        }
      />
      {(hasDueDatePermission || hasDueDateEditPermission) ? (
        <Route
          path=":id"
          element={
            <DueDateDetail
              originalUrl={originalUrl}
              canEdit={hasDueDateEditPermission}
            />
          }
        />
      ) : null}
      {hasDueDatePermission ? (
        <Route
          path="*"
          element={
            <DueDateList
              canCreateDuedate={hasDueDateCreatePermission}
              canEditDuedate={hasDueDateEditPermission}
              canDeleteDuedate={hasDueDateDeletePermission}
              originalUrl={originalUrl}
              {...otherProps}
            />
          }
        />
      ) : null}
    </Routes>
  )
}

export default DueDate